const mutations = {
  // 设置有效商品列表
  muTrolleyList(state, payload) {
    let result = [];
    result = payload.data.list || [];
    result.forEach(item => {
      if (item.isSpecil == 1) {
        // 后台返回的规格顺序不正确，更具orderBy正序排列
        if (item.spceil && item.spceil.length > 1) {
          item.spceil = item.spceil.sort((a, b) => a.orderBy - b.orderBy);
        }
        const upSpecil = item['spceil'] && item['spceil'][0] || {};
        const downSpecil = item['spceil'] && item['spceil'][1] || {};
        item.upSpecilId = upSpecil.specilId || '';
        item.upSpecilValue = upSpecil.specilName || '';
        item.downSpecilId = downSpecil.specilId || '';
        item.downSpecilValue = downSpecil.specilName || '';
      }
      if (item.goodsSkuId === '0') {
        item.goodsSkuId = '';
      }
    });
    state.goodsList = result;
  },
};
export default mutations;
